export default __webpack_public_path__ + "static/1370-6838edb85895d17500d3021a6ab1fd43.gif";